<template>
	<div>
		<label> {{ $t(`form${capitalize(field.name)}`) }}<span v-if="field.required"> *</span> </label>
		<client-only>
			<date-picker v-model:value="dateValue" value-type="format" format="DD-MM-YYYY" :lang="datepickerLang">
				<template #icon-calendar> &nbsp; </template>
			</date-picker>
		</client-only>
	</div>
</template>

<script setup lang="ts">
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import datePickerTranslations from '~~/i18n/datePicker';

defineProps<{
	field: FormField;
}>();

const dateValue = defineModel<string>('datefield');

const { locale } = useI18n();

const datepickerLang = computed(() => datePickerTranslations[locale.value]);
</script>

<style lang="scss" scoped>
:deep(.mx-datepicker) {
	width: 100%;
}

:deep(.mx-input) {
	height: auto;
	font-size: unset;
	color: unset;

	&:focus,
	&:hover {
		border-color: transparent;
	}

	&:focus {
		outline: revert;
	}
}
</style>
